var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftGivenIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gift_Given_icon_64x64",
    "data-name": "Gift Given icon 64x64",
    transform: "translate(-327 -361)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_64x64",
    "data-name": "64x64",
    width: 64,
    height: 64,
    transform: "translate(327 361)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "gift_icon",
    "data-name": "gift icon",
    transform: "translate(339 373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M36,12V32H4V12",
    transform: "translate(0 8)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M2,7H42V17H2Z",
    transform: "translate(-2 3)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M12,37V7",
    transform: "translate(8 3)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M19,12H10A5,5,0,0,1,10,2C17,2,19,12,19,12Z",
    transform: "translate(1 -2)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M12,12h9A5,5,0,0,0,21,2C14,2,12,12,12,12Z",
    transform: "translate(8 -2)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "clock_icon",
    "data-name": "clock icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(363 397)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(365 399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M10,6.889V10l2.333,2.333M17,10a7,7,0,1,1-7-7A7,7,0,0,1,17,10Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftGivenIcon);
export default __webpack_public_path__ + "static/media/GiftGivenIcon.031285da7748bbd0ae708b048142f618.svg";
export { ForwardRef as ReactComponent };